
import store from "../util/store";
import { HomeMobileView  } from "../views/homeMobileView";
import {useIsMobile} from "../util/useIsMobile";
import {HomeDesktopView} from "../views/homeDesktopView";

function Home() {
   const isMobile = useIsMobile();
  function handleStartButtonClickACB() {
    const state = store.getState();

    const uid = state.userData.userProfile?.Uid;

    if (uid) {
      window.location.hash = "#/mapOverview";
    } else {
      window.location.hash = "#/login";
    }
  }

  function handleAboutUsClickACB() {
    window.location.hash = "#/about";
  }
  const View = isMobile ? HomeMobileView : HomeDesktopView;

  return <View onStartClick={handleStartButtonClickACB} onAboutus={handleAboutUsClickACB} />;
  
}

export { Home };

